<template>
	<div class="feedback">
		<Form ref="feedForm" class="feedForm" :model="feedForm" :rules="feedRules" :label-width="80">
			<FormItem prop="email" label="邮箱地址: ">
				<Input v-model="feedForm.email" placeholder="如果方便，请提供您的邮箱地址"/>
			</FormItem>
			<FormItem prop="content" label="正文: ">
				<Input v-model="feedForm.content" type="textarea" :rows="4" placeholder="感谢您的反馈与建议"/>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="Submit()">提交</Button>
				<Button type="primary" @click="OpenIssue()" style="margin-left: 10px;">Issue</Button>
			</FormItem>
		</Form>
		<div class="feedList">
			<Collapse>
				<Panel :name="index.toString()" :key="index" v-for="(item,index) in feedList">
					<span class="email" v-text="item.email"></span>
					<span class="created_at" v-text="item.created_at"></span>
					<div slot="content">
						<p v-text="item.content"></p><br>
						<Alert type="success" v-if="item.replay !== null" v-text="'回复: '+item.replay"></Alert>
					</div>
				</Panel>
			</Collapse>
		</div>
	</div>
</template>

<script>
	export default {
		name: "feedback",
		data: ()=>{
			return {
				feedForm: {
					email: '',
					content: '',
				},
				feedRules: {
					content: [
						{type: 'string', required: true, message: '请输入反馈正文', trigger: 'blur'},
					],
				},
				feedList: {},
			};
		},
		methods: {
			Submit(){
				this.$refs['feedForm'].validate((valid)=>{
					if(valid){
						this.$fetch.util.create_feedback(this.feedForm).then(data=>{
							this.$Notice.success({title: '提交成功'});
							this.GetList();
						});
					}
				});
			},
			OpenIssue(){
				window.open('https://github.com/bytelang/bytelang-issue/issues');
			},
			GetList(page = 1){
				this.$fetch.util.get_feedback_list({count: 50}).then(data=>{
					this.feedList = data.data;
				});
			}
		},
		created(){
			this.GetList();
		}
	}
</script>

<style scoped lang="less">
	.feedback {
		padding: 30px 200px;
		
		.feedForm {
			padding: 0 50px;
		}
		
		.feedList {
			.created_at {
				float: right;
				margin-right: 20px;
			}
		}
	}
</style>